/**
 * Section — a white card that groups related content, with an optional title row.
 *
 * Props:
 *   title     node    card title (16px, semibold)
 *   extra     node    content on the far side of the title row (buttons, links)
 *   padded    bool    inner padding (default true; set false for edge-to-edge tables)
 *   children  node
 *
 * Usage:
 *   <Section title="היסטוריה" extra={<Button size="small">הוסף</Button>}>…</Section>
 */
import React from 'react';
import styles from './Section.css';

const Section = ({ title, extra, padded = true, className, children }) => (
  <section className={[styles.section, className].filter(Boolean).join(' ')}>
    {title || extra ? (
      <div className={styles.head}>
        <h3 className={styles.title}>{title}</h3>
        {extra ? <div className={styles.extra}>{extra}</div> : null}
      </div>
    ) : null}
    <div className={padded ? styles.body : undefined}>{children}</div>
  </section>
);

export default Section;
